import { api } from "./api";

export interface DriverZone {
  id: string;
  name: string;
  zoneNumber: number;
}

export interface Driver {
  id: string;
  firstName: string;
  lastName: string;
  name?: string; // firstName + lastName (livraisons)
  phone?: string | null;
  email?: string | null;
  userId: string;
  user?: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    email: string;
    phone: string | null;
  };
  isActive: boolean;
  hireDate?: string | null; // Date ISO string
  zones?: DriverZone[];
  zone?: { id: string; name: string };
  /** Adresse (contexte livraison, aplatie) */
  address?: string | null;
  city?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateDriverData {
  userId: string;
  isActive?: boolean;
  hireDate?: string; // Date ISO string (YYYY-MM-DD)
  zoneIds?: string[];
}

export interface UpdateDriverData extends Partial<CreateDriverData> {}

/**
 * Service pour la gestion des livreurs
 */
export const driverService = {
  /**
   * Récupère tous les livreurs
   */
  async getAll(includeInactive?: boolean): Promise<Driver[]> {
    const params: any = {};
    if (includeInactive !== undefined) {
      params.includeInactive = includeInactive;
    }
    const response = await api.get<{ success: boolean; data: Driver[] }>(
      "/drivers",
      { params },
    );
    return response.data.data;
  },

  /**
   * Récupère un livreur par son ID
   */
  async getById(id: string): Promise<Driver> {
    const response = await api.get<{ success: boolean; data: Driver }>(
      `/drivers/${id}`,
    );
    return response.data.data;
  },

  /**
   * Crée un nouveau livreur
   */
  async create(data: CreateDriverData): Promise<Driver> {
    const response = await api.post<{ success: boolean; data: Driver }>(
      "/drivers",
      data,
    );
    return response.data.data;
  },

  /**
   * Met à jour un livreur
   */
  async update(id: string, data: UpdateDriverData): Promise<Driver> {
    const response = await api.put<{ success: boolean; data: Driver }>(
      `/drivers/${id}`,
      data,
    );
    return response.data.data;
  },

  /**
   * Supprime un livreur
   */
  async delete(id: string): Promise<void> {
    await api.delete(`/drivers/${id}`);
  },
};
